import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import AuthRestAPI from "../../../restAPI/AuthRestAPI";
import moguLogo from "../../../assets/logo/mogu-logo-cover.png";
import AuthPageAside from "./AuthPageAside";
import "./AuthFlow.css";

const Brand = () => (
  <div className="brand">
    <span className="brand-mark brand-mark--login-cover">
      <img className="brand-mark-image-cover" src={moguLogo} alt="MOGU logo" />
    </span>
  </div>
);

const ForgotPasswordSent = () => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [cooldown, setCooldown] = useState(0);
  const [resendError, setResendError] = useState("");

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setInterval(() => setCooldown((c) => c - 1), 1000);
    return () => clearInterval(t);
  }, [cooldown]);

  const handleResend = async () => {
    if (cooldown > 0 || !email) return;
    setCooldown(30);
    setResendError("");
    try {
      await AuthRestAPI.resendForgotPassword(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId"),
        { email }
      );
    } catch (err) {
      setResendError(err?.response?.data?.message || "Unable to resend link right now.");
    }
  };

  return (
    <div className="shell">
      <section className="left">
        <Brand />
        <div className="form-wrap">
          <div className="success-icon">
            <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          </div>
          <h1>Check your <em>email</em></h1>
          <p className="subtitle">We sent a password reset link to <strong>{email || "your email address"}</strong>.</p>
          {resendError && <div className="field-error" role="alert">{resendError}</div>}
          <button type="button" className="btn-secondary" onClick={handleResend} disabled={cooldown > 0 || !email}>
            {cooldown > 0 ? `Send Reset Link (${cooldown}s)` : "Send Reset Link"}
          </button>
          <button type="button" className="btn-secondary" onClick={() => navigate("/login")}>Back to sign in</button>
          <div className="foot"><span>© {new Date().getFullYear()} MOGU Sdn Bhd</span></div>
        </div>
      </section>

      <AuthPageAside>
        <div className="right-eyebrow">Email sent</div>
        <h2>Almost there - one more <em>step.</em></h2>
        <p className="lede">Open the email and click the secure reset link to choose your new password.</p>
        <div className="panel">
          <div className="panel-title" style={{ marginBottom: 18 }}>If the email doesn't arrive</div>
          <ul className="panel-list">
            <li><span className="ic">•</span><div><strong>Check spam or promotions.</strong></div></li>
            <li><span className="ic">•</span><div><strong>Confirm the email address is correct.</strong></div></li>
            <li><span className="ic">•</span><div><strong>Try resending after 30 seconds.</strong></div></li>
          </ul>
        </div>
      </AuthPageAside>
    </div>
  );
};

export default ForgotPasswordSent;
